// extracted by mini-css-extract-plugin
export default {"mobile-warning":"mobile-warning__333gz"};